import React from "react";
import { Menu } from "antd";
import type { MenuInfo } from "rc-menu/lib/interface";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
interface RoleMenuProps {}

const ClientMenu: React.FC<RoleMenuProps> = ({}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleMenuClick = (e: MenuInfo) => {
    navigate("/settings/client", { state: { type: e.key } });
  };
  return (
    <>
      <Menu onClick={handleMenuClick} mode="vertical" selectedKeys={[]}>
        <Menu.Item key="screening" className="delete_message">
          {t("screening")}
        </Menu.Item>
        <Menu.Item key="monitoring" className="delete_message">
          {t("monitoring")}
        </Menu.Item>
        <Menu.Item key="vitalert" className="delete_message">
          {t("vitAlert")}
        </Menu.Item>
        <Menu.Item key="channel_partner" className="delete_message">
          {t("channel_partner")}
        </Menu.Item>
      </Menu>
    </>
  );
};

export default ClientMenu;
